import React from 'react';
import classnames from 'classnames';
import { history } from 'umi';
import COSDocPreviewer, { NavigatorToolbar } from '@gp/components/COSDocPreviewer';
import CommonNoAuthPageAccess from './CommonNoAuthPageAccess';
import { getBIDSTencentQCouldMassage } from '@sg/services/cos';
import { ENV } from '@home/_config/config';
import type { IBaseProps } from '@home/types/common';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';

interface IStudiosDocPreviewerProps extends IBaseProps {
  // 预览文档的cos的存储的key
  doc_key: string;
  doc_name?: string;
  doc_suffix?: string;
  studio_id?: string | number; // Studio ID for navigation back to Studios page
  cos_domain?: string; // COS config domain from URL params (for reusing previewer across different sections)
}

// Require login to view documents (ensures watermark is always applied)
const getAuth = async (): Promise<boolean> => {
  const userName = sessionStorage.getItem('userName');
  // Only allow access if user is logged in (has userName)
  return !!userName;
};

const StudiosDocPreviewer: React.FC<IStudiosDocPreviewerProps> = (props) => {
  const {
    style,
    className,
    doc_key: docKey,
    doc_name: docName = '',
    doc_suffix: docSuffix = '',
    studio_id: studioId,
    cos_domain: cosDomain,
  } = props;

  const handleNavigatorClick = () => {
    // Store the Notes scroll indicator before navigating back.
    if (studioId) {
      storage.setSessionStorageItem(STRATEGIC_STORAGE_KEY.STUDIOS_NOTES_ID, 'true');
    }
    
    // Navigate back with studio_id in URL
    const urlParams = studioId 
      ? `tab=studio&subtitle=studio&studio_id=${studioId}`
      : 'tab=studio&subtitle=studio';
    
    history.replace(`/strategic/home?${urlParams}`);
  };

  // 全球加速，预发布和正式
  const controlledEnv = ['pre', 'pro'];
  const isUseAccelerate = controlledEnv.includes(ENV);

  // Path for this previewer type - use cos_domain from URL if provided, otherwise default
  const cosPath = cosDomain || 'mgmt/board_governance';

  return (
    <div style={style} className={classnames('dbs-studios-doc-previewer', className)}>
      <COSDocPreviewer
        docKey={docKey}
        docName={docName}
        docSuffix={docSuffix}
        cosOptions={{
          useAccelerate: isUseAccelerate,
          baseCOSConfigFetcher: () => getBIDSTencentQCouldMassage(cosPath),
          authorizationFetcher: (_options?: any) => getBIDSTencentQCouldMassage(cosPath),
        }}
        getAuthParams={{}}
        getAuth={getAuth}
        toolbar={<NavigatorToolbar title="Back to Studios" onNavigatorClick={handleNavigatorClick} />}
        noAuth={<CommonNoAuthPageAccess />}
      />
    </div>
  );
};

export default StudiosDocPreviewer;
